// extracted by mini-css-extract-plugin
export var layout = "layout-module--layout--uJiLM";
export var layout_safeOverflow = "layout-module--layout_safe-overflow--Fx60q";